import { Component, inject, signal } from '@angular/core';
import { UiModule } from '@components/ui/ui-module';
import { Scrap } from '@services/scrap.service';
import { Proxy } from '@models/scrap.model';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { Router } from '@services/route.service';

@Component({
  selector: 'lgb-proxy-form',
  imports: [
    RouterModule,
    FormsModule,
    UiModule
  ],
  templateUrl: './proxy-form.html',
  styleUrl: './proxy-form.css',
})
export class ProxyForm {
  //service
  readonly scrapS=inject(Scrap);
  readonly router=inject(Router);
  readonly route=inject(ActivatedRoute);

  //data
  readonly proxy=signal<Proxy>(new Proxy());
  readonly isUpdate=signal(false);

  //ui
  readonly loading=signal(false);
  readonly msg=signal<string>(null);
  readonly error=signal<string>(null);

  constructor(){
    this.loading.set(true);
    this.route.paramMap
      .pipe(
        switchMap(params => {
          if(params.get('ident')){
            this.isUpdate.set(true);
            return this.scrapS.getProxy(params.get('ident'));
          }
          else
            return of(new Proxy());
        })
      )
      .subscribe(proxy => {
        this.proxy.set(proxy);
        this.loading.set(false);
      });
  }

  setProxy(){
    this.loading.set(true);
    let set$: Observable<Proxy>=this.scrapS.addProxie(this.proxy());
    if(this.isUpdate())
      set$=this.scrapS.setProxie(this.proxy());

    set$.subscribe({
        next: proxy => {
          this.proxy.set(proxy);
          this.msg.set(`Proxy ${((this.isUpdate())? 'modifié' : 'ajouté')}.`);
          this.isUpdate.set(true);
          this.loading.set(false);
        },
        error: e => {
          this.error.set(e);
          this.loading.set(false);
        }
      });
  }
}
